import {Injectable, Inject} from '@angular/core';
import { Http, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { TipologiaMenu } from '../models/data.model';


@Injectable({
  providedIn: 'root'
})
export class FileService {

  private BASE_URL: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) { 
    this.BASE_URL = baseUrl;
  }

  

  downloadFile(url): Observable<Blob>{		

    return this.http.get(this.BASE_URL + url, { responseType: "blob" });
		//return this.http.get('http://localhost:8080/employees/download', { responseType: ResponseContentType.Blob });
   }

   public getAllTipologies = () =>{//Public function to get json file
     return this.http.get("./assets/config/tipologis.json");
   }
  public getAllIdTipologieUserManuals = () => {//Public function to get json file
    return this.http.get("./assets/config/IdTipologieUserManuals.json");
  }
}
